import { createElement } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import omit from 'just-omit';

var omitProps = function omitProps() {
  for (var _len = arguments.length, propsToOmit = Array(_len), _key = 0; _key < _len; _key++) {
    propsToOmit[_key] = arguments[_key];
  }

  return function (Target) {
    var OmitProps = function OmitProps(props) {
      return createElement(Target, omit(props, propsToOmit));
    };

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(Target, 'omitProps'))(OmitProps);
    }

    return OmitProps;
  };
};

export default omitProps;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hocs/omit-props/build/browser-esm/index.js
// module id = 198
// module chunks = 0